var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#573E2F",
    fillRule: "evenodd",
    d: "M2.5 11.667c.46 0 .834.373.834.833v3.333a.833.833 0 0 0 .833.834h11.667a.833.833 0 0 0 .833-.834V12.5a.833.833 0 0 1 1.667 0v3.333a2.5 2.5 0 0 1-2.5 2.5H4.167a2.5 2.5 0 0 1-2.5-2.5V12.5c0-.46.373-.833.833-.833",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#573E2F",
    fillRule: "evenodd",
    d: "M5.244 7.744a.833.833 0 0 1 1.179 0L10 11.322l3.577-3.578a.833.833 0 1 1 1.179 1.179l-4.167 4.166a.833.833 0 0 1-1.178 0L5.244 8.923a.833.833 0 0 1 0-1.179",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#573E2F",
    fillRule: "evenodd",
    d: "M10 1.667c.46 0 .834.373.834.833v10a.833.833 0 0 1-1.667 0v-10c0-.46.373-.833.833-.833",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;